/* eslint @typescript-eslint/naming-convention: 0 */

import { buildWabunkaItemParamsByExperienceEvent, type ItemParams } from '@/wabunka-src/common/utils/googleAnalytics/common/wabunkaItem';
import { type Currency } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { WabunkaReservationFormStep1 } from '@/wabunka-src/features/Experience';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

export interface BeginCheckoutParams {
  value: number;
  currency: Currency;
  items: ItemParams[];
}
const buildBeginCheckoutParams = (experienceEvent: WabunkaExperienceEventViewModel, totalPriceIncludingTax: number): BeginCheckoutParams => {
  const item = buildWabunkaItemParamsByExperienceEvent(experienceEvent);
  return {
    value: totalPriceIncludingTax,
    currency: 'JPY',
    items: [item],
  };
};

/**
 * 発火タイミング：体験詳細にて、催行日・時間を選択した後Nextを押下時
 */
export const sendGAWabunkaBeginCheckoutEvent = (experienceEvent: WabunkaExperienceEventViewModel, form: WabunkaReservationFormStep1, totalPriceIncludingTax: number) => {
  sendWabunkaGAEvent('begin_checkout', buildBeginCheckoutParams(experienceEvent, totalPriceIncludingTax));
};
